function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "canvas__node_icon_svgVariable-shape",
  cx: 22,
  cy: 22,
  r: 20,
  fill: "#FFFFFF",
  stroke: "#373A3C",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6562 34L11.9805 12.5254H16.6826L22.1172 28.4189L27.376 12.5254H31.9756L24.2852 34H19.6562Z",
  fill: "#373A3C"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: -2,
  y1: 11.5,
  x2: -2,
  y2: 44
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: -2,
  y1: 11.5,
  x2: 11.5,
  y2: -2
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: 11.5,
  y1: -2,
  x2: 30.5,
  y2: -2
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: 30.5,
  y1: -2,
  x2: 44,
  y2: 11.5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: 44,
  y1: 11.5,
  x2: 44,
  y2: 44
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "node_center",
  cx: 21,
  cy: 21,
  r: 2
});

var SvgVariable = function SvgVariable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVariable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/variable.80ca73c6.svg";
export { ForwardRef as ReactComponent };